module.exports = __webpack_public_path__ + "img/pic-2.72668015.png";